import React, { useEffect, useState } from 'react';
import { IPromotionDetails } from 'utils/hooks/http/promotions.http';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';
import useHttp from 'utils/hooks/useHttp';
import Promotion from 'components/Promotions/Default/Promotion';
import './AutomotorHomePage.scss';
import { useTranslation } from 'react-i18next';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import { useNavigate } from 'react-router-dom';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { getTariffs } from 'store/selectors/automotor-tariff.selector';
import TariffsAutomotor from './TariffsAutomotor/TariffsAutomotor';
import i18n from 'i18n';
import CustomerOrder from './CustomerOrder/CustomerOrder';
import { RootState } from 'store/store';
import { setReloadOrderList } from 'store/slices/proformaAutomotorModal.slice';
import EspaceAutomotorRemainingV2 from '../espace-automotor-remaining-v2/EspaceAutomotorRemainingV2';

type Props = {};

const AutomotorHomePage: React.FC<Props> = () => {
  const http = useHttp();
  const navigate = useNavigate();
  const [promotionItems, setPromotionItems] = useState<IPromotionDetails[]>([]);
  const { isMobile, isTablet } = useDeviceDetect();
  const { t } = useTranslation();
  // const tariffs = useSelector(getTariffs);
  const { reloadOrderList } = useSelector((state: RootState) => state.proformaAutomotorModal);
  const dispatch = useDispatch();

  useEffect(() => {
    if (reloadOrderList) {
      dispatch(setReloadOrderList(false));
    } else {
      getPromotions();
    }
  }, [i18n.language, reloadOrderList]);

  function getPromotions() {
    http.promotions.activePromotions().then((res) => {
      setPromotionItems(res.data);
    });
  }

  return <div className="automotor-home-page">
    <div className="order-table-upload-container">
      <div className="orders-table">
        <div className="title-button-container">
          <div className="title-table">{t('_order_availability')}</div>
          <div className="button-table">
            <DefaultButton className="more-orders" text={t('_all_backorders')} onClick={() => navigate('/automotor-online/order/remaining')} />
          </div>
        </div>
        <EspaceAutomotorRemainingV2 embedded perPage={5} />
      </div>
    </div>

    <div className={`promotion ${promotionItems.length == 0 ? '' : 'promotion-show'} slideshow-container`}>
      {promotionItems.length ?
        <Promotion
          items={promotionItems}
          slidesPerView="auto"
          navigation={!(isMobile || isTablet) && promotionItems.length != 1}
          pagination={isMobile || isTablet}
          autoplay={promotionItems.length != 1}
          loop={promotionItems.length != 1}
          iconsArrowLeft={faChevronLeft}
          iconsArrowRight={faChevronRight}
        />
        : null
      }
    </div>

    {/* <TariffsAutomotor tariffs={tariffs} /> */}
    <CustomerOrder />

  </div >;
};

export default AutomotorHomePage;


